module.exports = __webpack_public_path__ + "img/img2.14d6cca8.png";